import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoyaltyBalanceResponse, LoyaltyRewardsResponse} from '../models/LoyaltyModels';

const REWARDS_URL = '/api/loyalty/rewards';
const BALANCE_URL = '/api/loyalty/balance';

// The one loyalty client — both the rewards page and the hotel checkout
// voucher picker call this, never a second/separate client.
@Injectable({providedIn: 'root'})
export class LoyaltyService {
    private http = inject(HttpClient);

    // withCredentials: needs the member's session cookie, same as the rest
    // of the checkout-payment calls in travel-stays.service.ts.
    getRewards(): Observable<LoyaltyRewardsResponse> {
        return this.http.get<LoyaltyRewardsResponse>(REWARDS_URL, {withCredentials: true});
    }

    getBalance(): Observable<LoyaltyBalanceResponse> {
        return this.http.get<LoyaltyBalanceResponse>(BALANCE_URL, {withCredentials: true});
    }
}
